import React from 'react'
import _ from 'lodash'
export function Summation(props) {

    let data = props.data
    let field = props.field
    let fields = props.fields
    let innerArray = props.innerArray
    let innerArrayFilterKey = props.innerArrayFilterKey
    let innerArrayFilterVal = props.innerArrayFilterVal
    if(data.length > 0) {
      let total = _.sum(_.map(data, d=>{

        if (innerArrayFilterKey && innerArrayFilterVal) {
          // eg: saleitem filter by item
          // sum of multiple fields in such item
            let matchedItems  = d[innerArray].filter((item)=>item[innerArrayFilterKey] === innerArrayFilterVal)
            let t = 0
            if(matchedItems.length) {

              matchedItems.forEach((item)=>{
                // sum of each field in item
                let is =  _.sum(_.map(fields, f=>{
                    return parseFloat(item[f])
                }))
                t = t + is

              })

              return t
            }

        }
        else if(innerArray) {
          return _.sum( _.map(d[innerArray], iA=>{
              return parseFloat(iA[field])
          }) )
        }
        else if(fields) {
          return _.sum(_.map(fields, f=>{
            return parseFloat(d[f])
          }))

        }
        else {
            return parseFloat(d[field])
        }
      }))

      total = parseFloat(total).toFixed(2)

      return <div className="text-right">
        {total}
        <div>
          {props.full_sum}
        </div>
      </div>
    }
    else {
      return null
    }

}



// WEBPACK FOOTER //
// ./src/components/commons/tablefooters.js